/** Only booleans count, so a non-DE response that omits the field never clears the DE flag. */
export const APP_GLOBAL_BANNER_STORAGE_KEY = "app_global_banner";

export const saveAppGlobalBannerFlag = (show: unknown): void => {
  if (typeof show !== "boolean") return;
  try {
    if (show) {
      window.localStorage.setItem(APP_GLOBAL_BANNER_STORAGE_KEY, "1");
    } else {
      window.localStorage.removeItem(APP_GLOBAL_BANNER_STORAGE_KEY);
    }
  } catch {
    // Storage can be unavailable (private mode, blocked). W7 then stays off.
  }
};
